import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { blogs } from "../data/blogs";
import BlogLayout from "../components/BlogLayout";

const Post = () => {
  const { slug } = useParams();
  const post = blogs.find((blog) => blog.slug === slug);

  useEffect(() => {
    document.body.classList.add("singleblogmbr");
    return () => document.body.classList.remove("blogmbr");
  }, []);

  if (!post) return <h2>Post not found</h2>;

  return (
    <>
      <Helmet>
        <title>{post.meta.title}</title>
        <meta name="description" content={post.meta.description} />
        <meta name="keywords" content={post.meta.keywords} />
      </Helmet>

      <BlogLayout
        title={post.title}
        shares={post.shares}
        sections={post.sections}
      />
    </>
  );
};

export default Post;
